import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPlanMgt from './reducers/plan-mgt.reducer';
import { EffectsModule } from '@ngrx/effects';
import { PlanMgtEffects } from './effects/plan-mgt.effects';
import * as fromPlanSetting from './reducers/plan-setting.reducer';
import {PlanSettingsEffects} from './effects/plan-settings.effects';
import * as fromPlanUserInfo from './reducers/plan-user-info.reducer';
import {PlanUserInfoEffects} from './effects/plan-user-info.effects';
import * as fromPlanList from './reducers/plan-list.reducer';
import {PlanListEffects} from './effects/plan-list.effects';
import * as fromPlanListFiler from './reducers/plan-list-filer.reducer';
import { PlanListFilerEffects } from './effects/plan-list-filer.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('planMgt', fromPlanMgt.reducer),
    EffectsModule.forFeature([PlanMgtEffects, PlanSettingsEffects, PlanUserInfoEffects, PlanListEffects, PlanListFilerEffects]),
    StoreModule.forFeature('planSetting', fromPlanSetting.reducer),
    StoreModule.forFeature('planUserInfo', fromPlanUserInfo.reducer),
    StoreModule.forFeature('planList', fromPlanList.reducer),
    StoreModule.forFeature('planListFiler', fromPlanListFiler.reducer),
  ]
})
export class PlanModule { }
